import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from '../middleware/auth'
import homeVue from '../views/home/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: homeVue,
    beforeEnter: auth
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/configuracoes/medida',
    name: 'Unidades de Medida',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/modules/configuracoes/unidade-medida/unidade-medida-list.vue'),
    beforeEnter: auth
  },
  {
    path: '/configuracoes/medida/novo',
    name: 'Unidades de Medida - Novo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/modules/configuracoes/unidade-medida/unidade-medida-form.vue'),
    beforeEnter: auth
  },
  {
    path: '/configuracoes/medida/editar/:id',
    name: 'Unidades de Medida - Editar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/modules/configuracoes/unidade-medida/unidade-medida-form.vue'),
    beforeEnter: auth
  },
  {
    path: '/estoque',
    name: 'Estoque',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Estoque/EstoqueItemList.vue'),
    beforeEnter: auth
  },
  {
    path: '/estoque/novo',
    name: 'Estoque - Novo Item',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Estoque/EstoqueItemForm.vue'),
    beforeEnter: auth
  },
  {
    path: '/estoque/editar/:id',
    name: 'Estoque - Editar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Estoque/EstoqueItemForm.vue'),
    beforeEnter: auth
  },
  {
    path: '/servico',
    name: 'Serviços',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Servico/ServicoList.vue'),
    beforeEnter: auth
  },
  {
    path: '/servico/novo',
    name: 'Serviço - Novo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Servico/ServicoForm.vue'),
    beforeEnter: auth
  },
  {
    path: '/servico/editar/:id',
    name: 'Serviço - Editar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Servico/ServicoForm.vue'),
    beforeEnter: auth
  },
  {
    path: '/projeto',
    name: 'Projetos',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/modules/projeto/projeto-list.vue'),
    beforeEnter: auth
  },
  {
    path: '/projeto/novo',
    name: 'Adicionar Projeto',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/modules/projeto/projeto-form.vue'),
    beforeEnter: auth
  },
  {
    path: '/projeto/editar/:id',
    name: 'Projeto - Editar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/modules/projeto/projeto-form.vue'),
    beforeEnter: auth
  },
]

const router = new VueRouter({
  routes
})

export default router
